function emailValidator() {
    return function email(value) {
        return (value && !!value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) || 'Gelieve een geldig e-mailadres in te voeren'
    }
}

function requiredValidator() {
    return function required(value) {
        return isDefined(value) || 'Dit is een verplicht veld'
    }
}

function minimumAmountValidator(amount) {
    return function minimumAmount(value) {
        return (isDefined(value) && value >= amount) || 'Het minimum bestelbedrag is €500'
    }
}

/*
 * Note that even though the name of this validator is "one per three", the actual calculation is not 1 per three.
 * Because the "other value" object has a items per unit of 6, you can actually get one bottle per 0.5 other value...
 */
function onePerThreeValidator() {
    return function onePerThree(valuesObject) {
        let errorMessage = 'Maximum 1 per 3 flessen toegelaten';
        let value = valuesObject.value;
        let otherValue = valuesObject.otherValue;
        if (isDefined(value) && !isDefined(otherValue)) {
            return errorMessage
        }
        if (isDefined(value) && isDefined(otherValue)) {
            return (otherValue / value) >= 0.5 || 'Maximum 1 per 3 flessen toegelaten'
        }
        return true;
    }
}

function isDefined(value) {
    return value !== undefined && value !== null && value !== '';
}

export {
    emailValidator,
    requiredValidator,
    minimumAmountValidator,
    onePerThreeValidator
}